import { render, staticRenderFns } from "./ShopMakePrice.vue?vue&type=template&id=219aa7f2"
import script from "./ShopMakePrice.vue?vue&type=script&lang=js"
export * from "./ShopMakePrice.vue?vue&type=script&lang=js"
import style0 from "./ShopMakePrice.vue?vue&type=style&index=0&id=219aa7f2&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports